import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 分页查询项目异议列表
export function getSupplierObjectionsListApi(params) {
  return request({
    url: baseUrl + '/workbench/supplier/objections/page',
    method: 'get',
    params
  })
}

// 供应商提出异议
export function setSupplierObjectionsQuestionApi(data) {
  return request({
    url: baseUrl + `/workbench/supplier/objections/question`,
    method: 'post',
    data
  })
}

// 供应商追加异议
export function setSupplierObjectionsAppendQuestionApi(data) {
  const { objectionId, ...other } = data
  return request({
    url: baseUrl + `/workbench/supplier/objections/${objectionId}/append-question`,
    method: 'post',
    data: other
  })
}

// 查询异议详情
export function getSupplierObjectionsDetailApi(objectionId) {
  return request({
    url: baseUrl + `/workbench/supplier/objections/${objectionId}/detail`,
    method: 'get'
  })
}
